@for (input of formConfig.inputs; track input.property; let i = $index) {
  <div class="main-section-item">
    @if (input.visible) {
      <div class="section-item">
        <div class="label-item">
          <div class="label-text">
            {{ "manager.inputs." + input.title + ".title" | translate }}
          </div>
          @if (input.mandatory) {
            <div class="label-input-mandatory">*</div>
          }
          @if (input.valid === false) {
            <div class="property-error">
              -
              {{
                input.errorMsg
                  ? input.errorMsg
                  : ("manager.inputs." + input.title + ".errorMsg" | translate)
              }}
            </div>
          }
        </div>
        @if (input.input) {
          <div class="property-input-text">
            <div
              [class]="
                input.type === 'password' ? 'password-item' : 'field-item'
              "
            >
              @if (input.property !== "creationDate") {
                <input
                  [class]="input.valid === false ? 'input-error' : 'input'"
                  [type]="
                    input.type === 'password'
                      ? hide
                        ? 'password'
                        : 'text'
                      : input.type
                  "
                  [placeholder]="
                    'manager.inputs.' + input.title + '.placeholder' | translate
                  "
                  [disabled]="input.id && update"
                  [(ngModel)]="objectCreated[input.property]"
                  (change)="onValidateForm(i, input)"
                />
              }
              @if (input.property === "creationDate") {
                <p class="creationDate" [disabled]="true">
                  {{ input.value | customDateComment }}
                </p>
              }
              @if (input.type === "password") {
                <mat-icon
                  class="visibility-icon"
                  matSuffix
                  (click)="hide = !hide"
                >
                  {{ hide ? "visibility_off" : "visibility" }}
                </mat-icon>
              }
            </div>
            <div class="bottom-border"></div>
          </div>
        }
        @if (input.selector) {
          <div
            [class]="input.valid === false ? 'selector-error' : 'selector-type'"
            [matMenuTriggerFor]="ItemMenu"
            (menuOpened)="changeArrow(input)"
            (menuClosed)="changeArrow(input)"
          >
            <div class="selector">
              <div class="list-box">
                <div class="list-box-label">
                  {{
                    objectCreated[input.property]
                      ? objectCreated[input.property]
                      : ("manager.inputs." + input.title + ".placeholder"
                        | translate)
                  }}
                </div>
                <div class="menu-icon">
                  <mat-icon>
                    {{
                      input.isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"
                    }}
                  </mat-icon>
                </div>
              </div>
            </div>
            <div class="bottom-border"></div>
            <mat-menu class="form-menu" #ItemMenu="matMenu">
              <div class="menu-holder">
                @for (
                  choice of input.choices;
                  track $index;
                  let isFirst = $first
                ) {
                  <div class="choice">
                    <div
                      [class]="isFirst ? 'first-choice' : 'choice-button'"
                      (click)="selectProp(choice, input.property, i, input)"
                    >
                      {{ choice }}
                    </div>
                  </div>
                }
              </div>
            </mat-menu>
          </div>
        }
        @if (input.search_selector) {
          <div
            [class]="input.valid === false ? 'selector-error' : 'selector-type'"
            [matMenuTriggerFor]="ItemMenu"
            (menuOpened)="changeArrow(input)"
            (menuClosed)="changeArrow(input)"
          >
            <div class="selector">
              <div class="list-box">
                <div class="list-box-label">
                  @if (input.search_selector) {
                    <input
                      class="search_selector_input"
                      [type]="text"
                      [placeholder]="'Filter ' + (input.title | translate)"
                      [ngModel]="
                        !pipeData
                          ? input.filter
                          : (input.filter | objectTransform)
                      "
                      (ngModelChange)="input.filter = $event"
                      (input)="onFilterChange(input)"
                    />
                  }
                </div>
                <div class="menu-icon">
                  <mat-icon>
                    {{
                      input.isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"
                    }}
                  </mat-icon>
                </div>
              </div>
            </div>
            <div class="bottom-border"></div>
            <mat-menu class="form-menu" #ItemMenu="matMenu">
              <div class="menu-holder">
                @for (
                  choice of input.filteredOptions;
                  track $index;
                  let isFirst = $first
                ) {
                  <div class="choice">
                    @if (input.search_selector) {
                      <div
                        [class]="isFirst ? 'first-choice' : 'choice-button'"
                        (click)="selectProp(choice, input.property, i, input)"
                      >
                        @if (input.property === "currentSite") {
                          <span>{{ choice | objectTransform }}</span>
                        }
                        @if (input.property !== "currentSite") {
                          <span>{{ choice }}</span>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </mat-menu>
          </div>
        }
      </div>
    }
  </div>
}
<div [ngStyle]="{ color: '#aaaaaa' }" class="requiredFields">
  <span>*</span>
  {{ "manager.form.requiredFields" | translate }}
</div>
